import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

export const useUser = computed(() => usePage().props.value?.authUser)

export const useOrganization = computed(
  () => usePage().props.value?.authOrganization
)
